module.exports = __webpack_public_path__ + "img/cm-area.f511d46e.svg";